export const MOVEMENT_STATUS = {
  SHIPPED: 'Shipped',
  DELIVERED: 'Delivered',
  PENDING: 'Pending'
}